module.exports = __webpack_public_path__ + "img/语音压缩banner 2.db99e3b0.png";